import React, { useEffect, useState } from "react";
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { StldCardPendenciaDeAprovacaoOptions } from "../../styled-components/StyledCardPendenciaDeAprovacaoOptions.style";
import { IconMenuDotsV } from "../../svg";
import { StyledTableDentroDoCard } from "../../styled-components/StyledTableDentroDoCard.style";
import api from '../../services/api';

export const CardNotasFiscais = (props) => {
    const {
        item,
        getCardId = { getCardId },
        index,
        openModalHistorico,
        loadOrdens
    } = props;

    const formatCurrency = (value) => {
        if (!value) {
            return 'R$ 0,00';
        }

        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
    };

    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';

        }
        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const [totalHoras, setTotalHoras] = useState(0);
    const [totalValor, settotalValor] = useState(0);

    useEffect(() => {
        let totalHoras = 0;
        let totalValor = 0;
        item.timesheets.forEach((tsItem) => {
            totalHoras += tsItem.totalHorasFaturadas;
            totalValor += tsItem.valorTotalFaturado;
        });
        setTotalHoras(totalHoras);
        settotalValor(totalValor);
    }, [item.Key])


    const cancelar = (item) => {
        Swal.fire({
            text: "Deseja realmente reemitir essa Nota Fiscal?",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                Swal.showLoading()
                console.log(item)
                try {
                    await api.delete(`Notafiscal/${item.notaFiscal.idNotaFiscal}`);
                    Swal.fire({
                        title: "Sucesso",
                        text: "Nota Fiscal enviada para reemissão com sucesso!",
                        icon: "success",
                        showConfirmButton: true
                    });
                    loadOrdens(null, 0, 10)
                } catch (err) {}
            }
          });
    }

    const salvarNota = async (item) => {        
        Swal.fire({
            text: 'Salvar Nota Fiscal na Pasta',
            allowOutsideClick: false,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            }).then(async (result) => {
                if (result.isConfirmed) {
                Swal.showLoading()
                try {
                    const retorno = await api.get(`Omie/webhook/salvarNotaFiscal/${item.notaFiscal.idNotaFiscal}`);
                    console.log(retorno.data);
                    Swal.fire({
                        title: retorno.data.data.statusCode = 204 ? "Atenção!" : "Sucesso",
                        text: retorno.data.data.statusCode = 204 ? `${retorno.data.data?.description}. Contate o Administrador do Sistema` : "Nota Fiscal salva na pasta com sucesso!",
                        icon: retorno.data.data.statusCode = 204 ? "warning" : "success",
                        showConfirmButton: true
                    });
                } catch (err) {}
            }
        });
    };

    return (
        <StldCardPendenciaDeAprovacaoOptions>
            <Flex style={{ display: "initial" }} onMouseOut={() => getCardId(`${index}`)} onMouseOver={() => getCardId(`${index}`)}>
                <Flex.Item className="card-menu-title">
                </Flex.Item>
                <Flex.Item className="card-menu-title-right">
                    <ul id={`${index}`} className="card-menu-hide">
                        <li className="menu-card" onClick={() => openModalHistorico(item)}>Detalhes</li>
                        {
                            item.notaFiscal.status == 'Faturado' &&
                            (<>
                                <li className="menu-card" onClick={() => cancelar(item)}>Reemitir</li>
                            </>)
                        }
                        {

                            (item.notaFiscal.status == 'Faturado' || item.notaFiscal.status == 'Recebido') &&
                            (<>
                                <li className="menu-card" onClick={() => salvarNota(item)}>Salvar na Pasta</li>
                            </>)
                        }
                    </ul>
                </Flex.Item>
            </Flex>
            <div className="card-align" style={{overflow: "hidden"}}>
                <Flex>
                    <Flex.Item className="flex-title-left">
                        <span className="legend-title-text-bold">Nota Fiscal: {item.notaFiscal.numero} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-title-text-bold">
                            {item.notaFiscal.status}
                        </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-title-right">
                        <span>
                            <button className="button-icon" onMouseOut={() => getCardId(`${index}`)} onMouseOver={() => getCardId(`${index}`)}><IconMenuDotsV /></button>
                        </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="legend-title-text"> Faturado em:  </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-title-text"> {item.notaFiscal.dataCadastro} </span>
                    </Flex.Item>
                </Flex>

                {
                    item.notaFiscal.status == 'Reemitida' && 
                    <Flex>
                        <Flex.Item className="flex-column-left">
                            <span className="legend-title-text"> Reemitida em:  </span>
                        </Flex.Item>
                        <Flex.Item className="flex-column-right">
                            <span className="legend-title-text"> {item.notaFiscal.dataReemissao} </span>
                        </Flex.Item>
                    </Flex>
                }

                {
                    item.notaFiscal.status == 'Cancelado' && 
                    <Flex>
                        <Flex.Item className="flex-column-left">
                            <span className="legend-title-text"> Cancelado em:  </span>
                        </Flex.Item>
                        <Flex.Item className="flex-column-right">
                            <span className="legend-title-text"> {item.notaFiscal.dataCancelamento} </span>
                        </Flex.Item>
                    </Flex>
                }

                {
                    item.notaFiscal.status == 'Recebido' && 
                    <Flex>
                        <Flex.Item className="flex-column-left">
                            <span className="legend-title-text"> Recebido em:  </span>
                        </Flex.Item>
                        <Flex.Item className="flex-column-right">
                            <span className="legend-title-text"> {item.notaFiscal.dataRecebimento} </span>
                        </Flex.Item>
                    </Flex>
                }

                <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="legend-title-text"> Valor NF</span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-title-text"> {item.notaFiscal.valorTotal} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="legend-title-text"> Valor dos Impostos</span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-title-text"> {item.notaFiscal.status == 'Recebido' ? item.notaFiscal.valorImpostos : "R$ 0,00"} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="legend-title-text"> Valor Liq. Recebido</span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-title-text"> {item.notaFiscal.valorTotalRecebido} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left text-max-50">
                        <span className="legend-title-text" title={item.notaFiscal.cliente.nome}> {item.notaFiscal.cliente.nome} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <StyledTableDentroDoCard>
                        <div style={{fontSize: "13px"}}> Timesheet </div>
                        <div className="table-responsive">
                            <table className="table table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col">Sigla</th>
                                        <th scope="col">TS</th>
                                        <th scope="col">Segurado</th>
                                        <th scope="col">Total Horas</th>
                                        <th scope="col">Valor Total</th>
                                        <th scope="col" className="text-center">Visualizar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.timesheets.map((tsItem) => {
                                        return (
                                            <tr>
                                                <td>{tsItem.pericia.sigla}</td>
                                                <td>{tsItem.timeSheetSigla}</td>
                                                <td>{tsItem.segurado.nome}</td>
                                                <td>{formatDecimal(tsItem.totalHorasFaturadas)}</td>
                                                <td>{formatCurrency(tsItem.valorTotalFaturado)}</td>
                                                <td className="text-center">
                                                    <Link target="_blank" className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: tsItem.idTimesheet }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16" style={{color: "#007bff"}}>
                                                            <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                            <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                        </svg>
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr className=" ">
                                        <td className="border-none text-center" colSpan={3}></td>
                                        <td className="border-none " >{formatDecimal(totalHoras)}</td>
                                        <td className="border-none " >{formatCurrency(totalValor)}</td>
                                        <td className="border-none " ></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </StyledTableDentroDoCard>
                </Flex>
            </div>
        </StldCardPendenciaDeAprovacaoOptions>
    );
};
